import React, { Fragment } from 'react'
import ReactDOM from 'react-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.min.css'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

// styles
import 'assets/css/bootstrap.min.css'
import 'assets/scss/paper-kit.scss'
import 'assets/demo/demo.css'
import Routes from './routes'
import { CAPTCHA_KEY } from './helpers/constants'
import { PanelProvider } from 'contexts/Panel'
import { AuthProvider } from 'contexts/Auth'

ReactDOM.render(
  <Fragment>
    <ToastContainer position="top-right" autoClose={5000} closeOnClick pauseOnHover />
    <GoogleReCaptchaProvider reCaptchaKey={CAPTCHA_KEY}>
      <PanelProvider>
        <AuthProvider>
          <Routes />
        </AuthProvider>
      </PanelProvider>
    </GoogleReCaptchaProvider>
  </Fragment>,
  document.getElementById('root')
)
